import { ACCESS_CODE_DETAILS } from './index';
import { Action } from '../action';

export class AccessCodeDetailsInitAction implements Action {
	readonly type = ACCESS_CODE_DETAILS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AccessCodeDetailsDestroyAction implements Action {
	readonly type = ACCESS_CODE_DETAILS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AccessCodeDetailsClickAddAccessCodeAction implements Action {
	readonly type = ACCESS_CODE_DETAILS.CLICK_ADD_ACCESS_CODE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
